import React, { Fragment } from 'react';

import { Slide } from "../../display_wallet.js"
import { With3Tabs } from "../../components/With3Tabs";

import { Slide_SwapBot_Achats } from "./Slide_SwapBot_Achats.js"
import { Slide_SwapBot_Ventes } from "./Slide_SwapBot_Ventes.js"
import { Slide_SwapBot_Contrat } from "./Slide_SwapBot_Contrat.js"


export class Slide_SwapBot extends React.PureComponent {
	render() {
		var jsx_1 = <Slide_SwapBot_Achats {...this.props} />
		var jsx_2 = <Slide_SwapBot_Ventes {...this.props} />
		var jsx_3 = <Slide_SwapBot_Contrat {...this.props} />

		return (
			<Slide num={this.props.num} style={{ paddingTop: "0px", overflowX: "hidden" }}>
				<With3Tabs
					startingtab="1"

					title_tab1="Achats"
					title_tab2="Ventes"
					title_tab3="Contrat"

					content_tab1={jsx_1}
					content_tab2={jsx_2}
					content_tab3={jsx_3}
				/>
			</Slide>
		)
	}
}
